// extracted by mini-css-extract-plugin
export default {"lunbo":"index_lunbo_0bdSH","dotCurrent":"index_dotCurrent_jud6b","box":"index_box_CHMJ8","image":"index_image_u73w2","link":"index_link_-rB9-"};